import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate, FormattedMessage } from 'react-intl';
import Lottie from 'lottie-react';
import {
  DialogBody,
  Dialog,
  DialogContent,
  DialogHeader
} from '@ps-design-system/components/Dialog';

import animation from './header-animation.json';

const ModalHeader = () => {
  return <>
    <Lottie
      className="animation"
      animationData={animation}
      loop
      autoPlay
    />
    <h3 className="announcement-title">
      <div>*
        <FormattedMessage
          id="stream.attachments_announcement_modal.header_part_1"
          defaultMessage="Cue the confetti"
        />*
      </div>
      <div>
        <FormattedMessage
          id="stream.attachments_announcement_modal.header_part_2"
          defaultMessage="Attachments have arrived!"
        />&nbsp;🎉
      </div>
    </h3>
  </>;
};

const ModalBody = ({ releaseDate }) => {
  return <>
    <p className="announcement-description">
      <FormattedMessage
        id="stream.attachments_announcement_modal.body_text"
        defaultMessage="One of our most requested features is here! You can now send all the files, photos, and videos you wish."
      />
    </p>
    <p className="announcement-subtext">
      <FormattedMessage
        id="stream.attachments_announcement_modal.body_sub_text"
        defaultMessage="Available for all new bookings made after {date}."
        values={{ date: <FormattedDate value={releaseDate} /> }}
      />
    </p>
  </>;
};

export const AttachmentsAnnouncementModal = ({ show, setShowModal, releaseDate }) => {
  return (
    <Dialog open={show} onOpenChange={setShowModal}>
      <DialogContent className="AttachmentsAnnouncementModal">
        <DialogHeader headerAlignment="center" showCloseButton={true}>
          <ModalHeader />
        </DialogHeader>
        <DialogBody style={{ paddingBottom: '32px' }}>
          <ModalBody releaseDate={releaseDate} />
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
};

ModalBody.propTypes = {
  releaseDate: PropTypes.object
};

AttachmentsAnnouncementModal.propTypes = {
  releaseDate: PropTypes.object,
  show: PropTypes.bool,
  toggleShow: PropTypes.func,
  onClose: PropTypes.func
};
